export default {
    Folders: [],
    InfoUpload :{}
}